// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../fonts/Roboto/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../fonts/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../fonts/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./../fonts/Open_Sans/OpenSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./../fonts/Open_Sans/OpenSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./../fonts/Open_Sans/OpenSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./../fonts/Open_Sans/OpenSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

/* Body */
body {
  font-family: "Roboto", Arial, Verdana, Helvetica, sans-serif;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  padding: 0;
}

ul {
  list-style-type: none;
}

* {
  box-sizing: border-box;
}

/* Layout */
.container-fluid {
  max-width: 100vw;
  min-height: 100vh;
  background-color: #eceff1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  width: min(1320px, 100%);
}

.form-wrapper,
.endGame-wrapper {
  position: relative;
  margin: auto;
  background-color: #263238;
  border-radius: 1rem;
  padding: 3rem;
  width: min(500px, 100%);
  display: flex;
  flex-flow: column wrap;
  gap: 2rem;
  box-shadow: 0 0 30px 0.0625rem rgba(0, 0, 0, 0.3019607843);
  z-index: 2;
}

.gameboard-wrapper {
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 3rem;
  z-index: 2;
}

.setup-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  z-index: 2;
}

.row-button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

/* Typography */
.title,
.sub-title {
  color: #fff;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 700;
}

.title {
  text-transform: uppercase;
  font-size: 2.5rem;
}

.sub-title {
  font-size: 2rem;
  margin-bottom: 1rem;
}
.sub-title::first-letter {
  text-transform: capitalize;
}

.sub-title.player {
  color: #c8e6c9;
}
.sub-title.computer {
  color: #fff9c4;
}

.text-info {
  color: #607d8b;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-weight: 400;
  font-size: 1rem;
  text-align: left;
  margin: 0;
  padding: 0;
}

/* Spacing */
.me-1 {
  margin-right: 0.25rem;
}
.me-2 {
  margin-right: 0.5rem;
}

/* Form */
.form-row {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  padding: 1rem 0 0;
  width: 100%;
}

.form-control {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 2px solid #607d8b;
  outline: 0;
  font-size: 1.3rem;
  color: #fff;
  padding: 0.5rem;
  background: transparent;
  transition: border-color 0.3s;
}

.form-control::placeholder {
  color: transparent;
}

.form-control:placeholder-shown ~ .form-label {
  font-size: 1.3rem;
  cursor: text;
  top: 1.5rem;
  left: 0.5rem;
}

.form-label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.3s;
  font-size: 1rem;
  color: #607d8b;
}

.form-control:placeholder-shown {
  border: 0;
  border-bottom: 2px solid #607d8b;
}

.form-control:focus,
.form-control:focus:placeholder-shown {
  border-width: 3px;
  border-image: linear-gradient(to right, #607d8b, #fff);
  border-image-slice: 1;
}

.btn-submit,
.btn-playAgain,
.btn-reset {
  display: inline-flex;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 auto;
  background-color: #607d8b;
  color: #fff;
  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
}

.btn-reset {
  background-color: #fff;
  color: #607d8b;
}

.btn-submit:hover,
.btn-playAgain:hover,
.btn-submit:active,
.btn-playAgain {
  background-color: #546e7a;
  color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.btn-reset:hover,
.btn-reset:active {
  background-color: white;
  color: #546e7a;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

/* Gameboard */
.gameboard {
  position: relative;
  background-color: #263238;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 30px 0.0625rem rgba(0, 0, 0, 0.3019607843);
  z-index: 3;
}

.gameboard .row {
  display: flex;
}

.cell {
  position: relative;
  width: 3rem;
  height: 3rem;
  background-color: transparent;
  border: 1px solid #8198a3;
}

.gameboard-player .cell {
  background-color: rgba(200, 230, 201, 0.2);
}
.gameboard-player .cell.attacked {
  background-color: transparent;
}

.gameboard-player .cell.ship {
  background-color: #607d8b;
}

.gameboard-computer .cell {
  background-color: rgba(255, 249, 196, 0.25);
  cursor: crosshair;
}
.gameboard-computer .cell.attacked {
  cursor: default;
  background-color: transparent;
}

.cell.attacked::after,
.cell.ship.attacked::after {
  position: absolute;
  content: "";
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.cell.attacked::after {
  background-color: #0288d1;
}

.cell.ship.attacked {
  background-color: #607d8b;
  border: none;
}
.cell.ship.attacked::after {
  background-color: #ae1919;
}

/* Animation */
.btn {
  position: relative;
  overflow: hidden;
}

.btn span {
  position: absolute;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  transform: translate(-50%, -50%);
  animation: ripple 1s;
  opacity: 0;
}

/* Add animation */
@keyframes ripple {
  from {
    opacity: 1;
    transform: scale(0);
  }

  to {
    opacity: 0;
    transform: scale(10);
  }
}

@media only screen and (max-width: 1356px) {
  .cell {
    width: 2rem;
    height: 2rem;
  }
}

@media only screen and (max-width: 991px) {
  .gameboard-wrapper {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,qBAAqB;EACrB,+DAAiE;EACjE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAuE;EACvE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAwE;EACxE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,4DAA4D;EAC5D,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;;;;EASE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0DAA0D;EAC1D,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA,eAAe;AACf;;EAEE,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mDAAmD;EACnD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,iBAAiB;EACjB,sDAAsD;EACtD,qBAAqB;AACvB;;AAEA;;;EAGE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,8DAA8D;AAChE;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;EACX,uCAAuC;AACzC;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;EACd,uCAAuC;AACzC;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0DAA0D;EAC1D,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Fonts */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  src: url(\"./../fonts/Roboto/Roboto-Black.ttf\") format(\"truetype\");\r\n  font-weight: 900;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  src: url(\"./../fonts/Roboto/Roboto-Bold.ttf\") format(\"truetype\");\r\n  font-weight: 700;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  src: url(\"./../fonts/Roboto/Roboto-Medium.ttf\") format(\"truetype\");\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Open Sans\";\r\n  src: url(\"./../fonts/Open_Sans/OpenSans-SemiBold.ttf\") format(\"truetype\");\r\n  font-weight: 600;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Open Sans\";\r\n  src: url(\"./../fonts/Open_Sans/OpenSans-Medium.ttf\") format(\"truetype\");\r\n  font-weight: 500;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Open Sans\";\r\n  src: url(\"./../fonts/Open_Sans/OpenSans-Regular.ttf\") format(\"truetype\");\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"Open Sans\";\r\n  src: url(\"./../fonts/Open_Sans/OpenSans-Light.ttf\") format(\"truetype\");\r\n  font-weight: 300;\r\n  font-style: normal;\r\n  font-display: swap;\r\n}\r\n\r\n/* Body */\r\nbody {\r\n  font-family: \"Roboto\", Arial, Verdana, Helvetica, sans-serif;\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul,\r\nli,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul {\r\n  list-style-type: none;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Layout */\r\n.container-fluid {\r\n  max-width: 100vw;\r\n  min-height: 100vh;\r\n  background-color: #eceff1;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.container {\r\n  width: min(1320px, 100%);\r\n}\r\n\r\n.form-wrapper,\r\n.endGame-wrapper {\r\n  position: relative;\r\n  margin: auto;\r\n  background-color: #263238;\r\n  border-radius: 1rem;\r\n  padding: 3rem;\r\n  width: min(500px, 100%);\r\n  display: flex;\r\n  flex-flow: column wrap;\r\n  gap: 2rem;\r\n  box-shadow: 0 0 30px 0.0625rem rgba(0, 0, 0, 0.3019607843);\r\n  z-index: 2;\r\n}\r\n\r\n.gameboard-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  gap: 3rem;\r\n  z-index: 2;\r\n}\r\n\r\n.setup-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 2rem;\r\n  z-index: 2;\r\n}\r\n\r\n.row-button {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 2rem;\r\n}\r\n\r\n/* Typography */\r\n.title,\r\n.sub-title {\r\n  color: #fff;\r\n  text-align: center;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  font-weight: 700;\r\n}\r\n\r\n.title {\r\n  text-transform: uppercase;\r\n  font-size: 2.5rem;\r\n}\r\n\r\n.sub-title {\r\n  font-size: 2rem;\r\n  margin-bottom: 1rem;\r\n}\r\n.sub-title::first-letter {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.sub-title.player {\r\n  color: #c8e6c9;\r\n}\r\n.sub-title.computer {\r\n  color: #fff9c4;\r\n}\r\n\r\n.text-info {\r\n  color: #607d8b;\r\n  font-family: \"Roboto\", Arial, Helvetica, sans-serif;\r\n  font-weight: 400;\r\n  font-size: 1rem;\r\n  text-align: left;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* Spacing */\r\n.me-1 {\r\n  margin-right: 0.25rem;\r\n}\r\n.me-2 {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n/* Form */\r\n.form-row {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n  position: relative;\r\n  padding: 1rem 0 0;\r\n  width: 100%;\r\n}\r\n\r\n.form-control {\r\n  font-family: inherit;\r\n  width: 100%;\r\n  border: 0;\r\n  border-bottom: 2px solid #607d8b;\r\n  outline: 0;\r\n  font-size: 1.3rem;\r\n  color: #fff;\r\n  padding: 0.5rem;\r\n  background: transparent;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n.form-control::placeholder {\r\n  color: transparent;\r\n}\r\n\r\n.form-control:placeholder-shown ~ .form-label {\r\n  font-size: 1.3rem;\r\n  cursor: text;\r\n  top: 1.5rem;\r\n  left: 0.5rem;\r\n}\r\n\r\n.form-label {\r\n  position: absolute;\r\n  top: 0;\r\n  display: block;\r\n  transition: 0.3s;\r\n  font-size: 1rem;\r\n  color: #607d8b;\r\n}\r\n\r\n.form-control:placeholder-shown {\r\n  border: 0;\r\n  border-bottom: 2px solid #607d8b;\r\n}\r\n\r\n.form-control:focus,\r\n.form-control:focus:placeholder-shown {\r\n  border-width: 3px;\r\n  border-image: linear-gradient(to right, #607d8b, #fff);\r\n  border-image-slice: 1;\r\n}\r\n\r\n.btn-submit,\r\n.btn-playAgain,\r\n.btn-reset {\r\n  display: inline-flex;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  margin: 0 auto;\r\n  background-color: #607d8b;\r\n  color: #fff;\r\n  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.btn-reset {\r\n  background-color: #fff;\r\n  color: #607d8b;\r\n}\r\n\r\n.btn-submit:hover,\r\n.btn-playAgain:hover,\r\n.btn-submit:active,\r\n.btn-playAgain {\r\n  background-color: #546e7a;\r\n  color: #fff;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.btn-reset:hover,\r\n.btn-reset:active {\r\n  background-color: white;\r\n  color: #546e7a;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Gameboard */\r\n.gameboard {\r\n  position: relative;\r\n  background-color: #263238;\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 0 30px 0.0625rem rgba(0, 0, 0, 0.3019607843);\r\n  z-index: 3;\r\n}\r\n\r\n.gameboard .row {\r\n  display: flex;\r\n}\r\n\r\n.cell {\r\n  position: relative;\r\n  width: 3rem;\r\n  height: 3rem;\r\n  background-color: transparent;\r\n  border: 1px solid #8198a3;\r\n}\r\n\r\n.gameboard-player .cell {\r\n  background-color: rgba(200, 230, 201, 0.2);\r\n}\r\n.gameboard-player .cell.attacked {\r\n  background-color: transparent;\r\n}\r\n\r\n.gameboard-player .cell.ship {\r\n  background-color: #607d8b;\r\n}\r\n\r\n.gameboard-computer .cell {\r\n  background-color: rgba(255, 249, 196, 0.25);\r\n  cursor: crosshair;\r\n}\r\n.gameboard-computer .cell.attacked {\r\n  cursor: default;\r\n  background-color: transparent;\r\n}\r\n\r\n.cell.attacked::after,\r\n.cell.ship.attacked::after {\r\n  position: absolute;\r\n  content: \"\";\r\n  border-radius: 50%;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.cell.attacked::after {\r\n  background-color: #0288d1;\r\n}\r\n\r\n.cell.ship.attacked {\r\n  background-color: #607d8b;\r\n  border: none;\r\n}\r\n.cell.ship.attacked::after {\r\n  background-color: #ae1919;\r\n}\r\n\r\n/* Animation */\r\n.btn {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.btn span {\r\n  position: absolute;\r\n  border-radius: 50%;\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  width: 100px;\r\n  height: 100px;\r\n  margin-top: -50px;\r\n  margin-left: -50px;\r\n  transform: translate(-50%, -50%);\r\n  animation: ripple 1s;\r\n  opacity: 0;\r\n}\r\n\r\n/* Add animation */\r\n@keyframes ripple {\r\n  from {\r\n    opacity: 1;\r\n    transform: scale(0);\r\n  }\r\n\r\n  to {\r\n    opacity: 0;\r\n    transform: scale(10);\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1356px) {\r\n  .cell {\r\n    width: 2rem;\r\n    height: 2rem;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n  .gameboard-wrapper {\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
